<template>
  <!-- Shared header for every auth form panel: a centralized (centered) icon,
       then title, then subtitle. Keeps Login, "Welcome back", Register and
       password-recovery visually identical. -->
  <div class="flex flex-col items-center gap-4 text-center">
    <span
      v-if="icon"
      class="flex h-14 w-14 items-center justify-center rounded-theme-md bg-theme-palette-emerald/10 text-theme-palette-emerald dark:bg-theme-palette-emerald/30 dark:text-theme-palette-emerald"
    >
      <icon :path="icon" size="28" />
    </span>
    <div>
      <h1 class="text-2xl font-bold text-theme-text">
        {{ title }}
      </h1>
      <p v-if="subtitle" class="mt-1 text-sm font-medium text-theme-text-secondary">
        {{ subtitle }}
      </p>
    </div>
  </div>
</template>

<script setup>
  import Icon from '@/components/Icon';

  defineProps({
    /** Optional mdi icon path shown above the title. */
    icon: { type: String, default: '' },
    title: { type: String, required: true },
    subtitle: { type: String, default: '' },
  });
</script>
